import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MenuComponent }          from './menu/menu.component';
import { MenuMultiplyComponent }  from './menu-multiply/menu-multiply.component';
import { MenuFractionsComponent } from './menu-fractions/menu-fractions.component';
import { MenuProcentComponent }   from './menu-procent/menu-procent.component';
import { MultiplyComponent }      from './multiply/multiply.component';
import { AddComponent }           from './add/add.component';
import { SubtractComponent }      from './subtract/subtract.component';
import { DivisionComponent }      from './division/division.component';
import { FractionsComponent }     from './fractions/fractions.component';
import { FractionsIntroComponent }     from './fractions-intro/fractions-intro.component';
import { FractionsExtendComponent }     from './fractions-extend/fractions-extend.component';
import { FractionsNumbersComponent }     from './fractions-numbers/fractions-numbers.component';
import { ScoringComponent }       from './scoring/scoring.component';

const routes: Routes = [
  { path: '', redirectTo: 'menu', pathMatch: 'full' },
  { path: 'menu', component: MenuComponent },
  { path: 'menu-multiply', component: MenuMultiplyComponent },
  { path: 'menu-fractions', component: MenuFractionsComponent },
  { path: 'menu-procentage', component: MenuProcentComponent },
  { path: 'multiply', component: MultiplyComponent },
  { path: 'add', component: AddComponent },
  { path: 'subtract', component: SubtractComponent },
  { path: 'division', component: DivisionComponent },
  { path: 'fractions', component: FractionsComponent },
  { path: 'fractions-intro', component: FractionsIntroComponent },
  { path: 'fractions-extend', component: FractionsExtendComponent },
  { path: 'fractions-numbers', component: FractionsNumbersComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes,{useHash:true}) ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/app-routing.module.ts